<template>
    <div class="realData">
        <page-header></page-header>
        <el-row class="set-option" v-if="!isMobile" type="flex" justify="space-between" align="middle">
            <el-col :span="3">
                <el-select @change="loadBrick" class="charts-input" v-model="option.aliasNo" placeholder="窑号">
                    <el-option v-for="item in sys_alias" :key="item.val" :label="item.label" :value="item.val">
                    </el-option>

                </el-select>

            </el-col>
            <el-col :span="3">
                <el-select class="charts-input" v-model="option.selectType" placeholder="类型">
                    <el-option v-for="item in chartsType" :key="item.val" :label="item.label" :value="item.val">
                    </el-option>
                </el-select>

            </el-col>
            <el-col class="chars-title" v-if="stand.list&&stand.list.length" :span="12">
                <el-select class="charts-input" @change="changeStandType" v-model="stand.type" placeholder="请选择砖类型">
                    <el-option v-for="(item,index) in stand.list" :key="index" :label="index+':'+item[index]"
                               :value="index">
                    </el-option>
                </el-select>
                <el-button type="text" @click="openSetStandType">砖类型设置</el-button>
            </el-col>
            <el-col  :span="6" style="text-align:right">
                <div style="padding: 0 10px;">
                    <el-button type="primary" :loading='loading.standard' @click="saveStandConf(true)">
                        {{loading.standard ? '正在加载' : '同步设置至设备'}}
                    </el-button>

                    <el-button type="primary" :loading='loading.standard' @click="loadStandConf(false)">
                        {{loading.standard ? '正在加载' : '刷新数据'}}
                    </el-button>
                </div>


                <!-- <el-button @click='setStandByrealData' v-if='userInfo.identity==="USER"&&isEdit' type='danger'>将实时数据设为标准参数</el-button> -->
            </el-col>
        </el-row>
        <!--mobile 顶部  -->
        <div v-if="isMobile" class="mobile-top-bar">
            <div>
                <div>
                    <el-select @change="loadBrick" class="charts-input" size='small' v-model="option.aliasNo" placeholder="窑号">
                        <el-option v-for="item in sys_alias" :key="item.val" :label="item.label" :value="item.val">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="stand.list&&stand.list.length">
                    <el-select class="charts-input" @change="changeStandType" size='small' v-model="stand.type"
                               placeholder="请选择砖类型">
                        <el-option v-for="(item,index) in stand.list" v-if="item[index]" :key="index"
                                   :label="item[index]" :value="index">
                        </el-option>
                    </el-select>

                </div>
                <div style="text-align:right">
                    <el-select size='small' class="charts-input" v-model="option.selectType" placeholder="类型">
                        <el-option v-for="item in chartsType" :key="item.val" :label="item.label" :value="item.val">
                        </el-option>
                    </el-select>
                </div>

            </div>
            <div>
                    <el-button @click="openSetStandType">砖类型设置</el-button>
                    <el-button  :loading='loading.standard' @click="saveStandConf(true)">
                    {{loading.standard ? '正在加载' : '同步设置至设备'}}
                </el-button>

            </div>

        </div>

        <template>
            <el-card v-if="loading.standard" class="box-card  css-margin-top no-padding">
                <loading></loading>
            </el-card>
            <el-card v-else v-for="(itemType,key) in standConf"
                     v-show="itemType&&itemType.length&&option.selectType===key" :key='key'
                     class="box-card  css-margin-top no-padding">
                <div class="clearfix chars-header">
          <span class="card-header-title">{{confTypeName[key]}}
            <span>（单位：℃)</span>
          </span>
                    <div v-if="!isMobile">
                        <el-button v-if="isEdit" type="text" @click="isEdit=false">取消</el-button>
                        <el-button @click="openEdit" :type="isEdit?'success':'text'">{{isEdit ? "保存并写入设备" : "编辑"}}
                        </el-button>
                    </div>
                </div>
                <div class="card-body ">
                    <div class="leemma-table">
                        <div v-for="item in itemType" v-bind:key="item.id">
                            <div class="leemma-table-th">
                                {{item.key}}
                            </div>
                            <div class="leemma-table-td">
                                <p v-if="!isEdit">{{item.data}}</p>
                                <el-input v-else v-model="item.data"></el-input>
                            </div>
                        </div>

                    </div>
                </div>
            </el-card>

            <!--工艺曲线图  -->
            <el-card v-show="!loading.echarts" class="box-card  css-margin-top quxian">
                <div class="clearfix chars-header">
                    <span class="card-header-title">标准参数对比曲线
                        <span>（单位：℃)</span>
                    </span>
                    <div class="time-show">
                        {{option.time_stamp}}

                    </div>
                <span></span>
                </div>
                <div v-if='!oldConf' class="img-no-data">
                    <img :src="img_no_data" alt="暂无数据">
                    <p>暂无数据</p>
                </div>
                <div v-else>
                    <div ref="charts"></div>
                </div>
            </el-card>
        </template>

        <el-dialog title="砖类型设置" :visible.sync="dialog.standType" size="large">
            <div class="dialog-body">
                <el-form :inline="true" label-width='30px' class="demo-form-inline">
                    <el-form-item v-for='(item,index) in stand.list' :key='index' :label="index.toString()">
                        <el-input :maxlength='20' v-model="item[index]" placeholder="砖类型"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="saveStandType">保存</el-button>
        <el-button @click="dialog.standType = false">关闭</el-button>
      </span>
        </el-dialog>

    </div>
</template>

<script>
import img_no_data from "../../assets/images/no_data.svg";

const echarts = require("echarts");
import { mapState } from "vuex";
import Lib from "../../lib/lib.js";


import pageHeader from "../../components/tempControl/header";
import loading from "../../components/common/loading.vue";

export default {
  name: "standardSet",
  components: {
    pageHeader,
    loading
  },
  data() {
    return {
      img_no_data,
      sys_alias: [],
      option: {
        aliasNo: "1",
        selectType: "shaojie",
        time_stamp: ""
      },
      //图表选项
      chartsType: [
        {
          val: "shaojie",
          label: "烧结"
        },
        {
          val: "honggan",
          label: "烘干"
        }
      ],
      max_pt: -1,
      max_dry: -1,
      loading: {
        standard: true,
        echarts: true
      },
      standConf: {},
      confTypeName: {
        shaojie: "烧结",
        cewen: "测温",
        honggan: "烘干",
        other: "其他",
        yali: "压力",
        fengji: "风机"
      },
      oldConf: "",
      isEdit: false,
      charts: "",
      // 实时数据和历史数据
      hisData: [],
      realData: {},
      // 图表数据
      chartsData: {},

      // 砖类型
      stand: {
        list: [],
        type: "",
        edit: {
          name: "",
          id: ""
        }
      },
      // 对话框控制
      dialog: {
        standType: false
      }
    };
  },
  watch: {
    "option.selectType"() {
      this.changeSelectType();
    }
  },
  created() {
    this.creatAliasMeun(this.deviceInfo.alias_m);
  },
  mounted() {
    this.loadBrick();
    Lib.M.selectInputFoc();
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      siderbarOpen: state => state.siderbarOpen,
      userInfo: state => state.userInfo,
      deviceInfo: state => state.deviceInfo
    })
  },
  methods: {
    /**
     * 创建窑号选框
     * @argument MaxAlias 最大窑数
     */
    creatAliasMeun(MaxAlias) {
      for (let i = 0; i < MaxAlias; i++) {
        this.sys_alias.push({
          val: `${i + 1}`,
          label: `${i + 1}号窑`
        });
      }
    },
    // 请求砖类型
    loadBrick() {
      let params = {
        conf_type: "brick",
        sys_alias: this.option.aliasNo,
        device_id: this.deviceInfo.device_id
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      Lib.api.loadDeviceConf(params, data => {
        if (data.status_code === "SUCCEEDED") {
          this.stand.type = data.payload.name;
          try {
            this.stand.list = JSON.parse(data.payload.list);
            this.stand.type = data.payload.name;
          } catch (error) {
            console.error({
              error,
              msg: "解析砖类型列表失败",
              data
            });
          }
        }
        this.loadHisData();
      });
    },

    /**
     * 获取标准参数并执行数据处理
     * */
    loadStandConf(is_cache) {
      this.loading.standard = true;
      let params = {
        conf_type: "standard",
        sys_alias: this.option.aliasNo,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache,
        name: this.stand.type ? this.stand.type : 30,
        payload: {
          devNo: this.option.aliasNo * 1,
          type: this.stand.type ? this.stand.type : 30
        }
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      Lib.api.loadDeviceConf(params, data => {
        if (data.status_code === "SUCCEEDED") {
        } else {
          if (!is_cache) {
            this.isEdit = false;
          }
          this.$message({
            message: "网络连接超时：" + data.msg,
            type: "warning"
          });
          if (!this.isMobile) {
            this.$notify.info({
              title: "温馨提示",
              message: "无法连接设备时，无法进行参数修改操作",
              duration: 3000,
              offset: 60
            });
          }
        }
        if (data.payload && data.payload.data) {
          let s = JSON.parse(data.payload.data);
          delete s.oother;
          delete s.msg;
          this.oldConf = s;
          this.standConf = this.dealApiData(s);
          this.option.time_stamp = data.payload.time_stamp;

          this.$nextTick(() => {
            this.dealChartsData("shaojie");
          });
        }
        this.loading.echarts = false;

        this.loading.standard = false;
      });
    },
    // 历史数据
    loadHisData() {
      let params = {
        device_id: this.deviceInfo.device_id,
        data_type: "realData",
        sys_alias: this.option.aliasNo,
        page_size: 5,
        page_no: 1
      };
  
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      Lib.api.loadDeviceData(params, data => {
        // 读取标准参数
        this.loadStandConf(true);

        if (data.status_code === "SUCCEEDED") {
          this.max_pt = data.payload.max_pt;
          this.max_dry = data.payload.max_dry;
          this.hisData = this.dealApiData(JSON.parse(data.payload.data));
          debugger
          this.realData = this.hisData;
        } else {
          console.error("历史数据接口：" + data.msg);
        }
      });
    },
    /**
     * 处理历史数据
     * @argument data 数据源
     */
    dealHisFn(data) {
      let hisData = [];
      if (data.length > 0) {
        let item;
        for (let i = 0; i < data.length; i++) {
          item = data[i];
          try {
            let r = this.dealApiData(JSON.parse(item.data));
            r.time_stamp = item.time_stamp;
            hisData.push(r);
          } catch (error) {
            console.error("历史数据处理err:" + error);
            console.error(item);
          }
        }
      }
      return hisData;
    },

    /**
     * 处理api数据,将实时数据和标准参数分类
     * @param data 待处理数据
     */
    dealApiData(data) {
      let shaojie = [],
        honggan = [],
        cewen = [],
        fengji = [],
        yali = [],
        other = [];
      let item, th;
      let jsonData = Object.assign(data.ki, data.ao, data.pi, data.ci);
        let nameRegExp={
            shaojie:/烧结|顶中|顶外|顶内|内侧|外侧|内|外|中/
        }
      for (item in jsonData) {
        let pushJson = {
          th: item,
          data: jsonData[item],
          key: item
        };
          if (nameRegExp.shaojie.test(item)) {
              pushJson.th = item.replace(/[^0-9]/g,"");
              shaojie.push(pushJson);
        } else if (item.search("烘干") !== -1) {
          pushJson.th = item.split("车位烘干")[0];
          honggan.push(pushJson);
        } else if (item.search("测温") !== -1) {
          cewen.push(pushJson);
        } else if (item.search("风机") !== -1) {
          fengji.push(pushJson);
        } else if (item.search("压力") !== -1) {
          yali.push(pushJson);
        } else {
          other.push(pushJson);
        }
      }

      // 排序
      function thSort(a, b) {
        if (a.th * 1 > b.th * 1) {
          return 1;
        } else {
          return -1;
        }
      }

      shaojie.sort(thSort);
      honggan.sort(thSort);
      return {
        shaojie,
        honggan,
        cewen,
        fengji,
        yali,
        other
      };
    },
    /**
     * 编辑状态的处理
     */
    openEdit() {
      if (this.isEdit) {
        this.saveStandConf(false);
      } else {
        if (this.userInfo.role === "manager" || this.userInfo.role) {
          this.loadStandConf(false);
          this.isEdit = true;
        } else {
          this.$message.error("权限不足，修改失败");
        }
      }
    },
    /**
     * 处理post数据
     * @param {object} data
     */
    delSaveData(data) {
      let _this = this,
        oldConf = _this.oldConf;

      // 检测修改数据
      function checkValue(type, value) {
        value = Math.floor(value);
        //                    switch (type) {
        //                        case "ki":
        //                            value > 1400 ? (value = 1400) : value;
        //                            value < 0 ? (value = 0) : value;
        //                            break;
        //                        case "pi":
        //                            value > 500 ? (value = 500) : value;
        //                            value < -500 ? (value = -500) : value;
        //                            break;
        //                        case "ci":
        //                            value > 100 ? (value = 100) : value;
        //                            value < 0 ? (value = 0) : value;
        //                            break;
        //                        case "ao":
        //                            value > 50 ? (value = 50) : value;
        //                            value < 0 ? (value = 0) : value;
        //                            break;
        //                        default:
        //                            break;
        //                    }
        return value;
      }
      /**
       * key匹配修改数据
       */
      function editValue(goal, value) {
        let key, subKey;
        for (key in oldConf) {
          for (subKey in oldConf[key]) {
            if (goal === subKey) {
              if (oldConf[key][subKey] == value) {
                return "normal";
              } else {
                oldConf[key][subKey] = checkValue(key, value);
                return "update";
              }
            }
          }
        }
      }

      let item;
      let jsonData = data.fengji.concat(
        data.fengji,
        data.honggan,
        data.cewen,
        data.shaojie,
        data.yali,
        data.other
      );
      for (item in jsonData) {
        let result = editValue(jsonData[item].key, jsonData[item].data);
        if (result === "update") {
          console.log(`标准配置：${jsonData[item].key}修改成功`);
        } else if (result === "normal") {
          // console.log(`标准配置：${jsonData[item].key}未改变`)
        } else {
          console.error(`标准配置：${jsonData[item].key}修改失败`);
        }
      }
      return oldConf;
    },
    /**
     * post标准参数 TODO 数据验证和返回处理
     * */
    saveStandConf(is_change) {
      let payload = this.delSaveData(this.standConf);
      this.loading.standard = true;
      payload.devNo = this.option.aliasNo * 1;
      let params = {
        conf_type: "standard",
        sys_alias: this.option.aliasNo,
        device_id: this.deviceInfo.device_id,
        is_change: is_change.toString(),
        payload: JSON.stringify(payload)
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      Lib.api.setDeviceConf(params, data => {
        if (data.status_code === "SUCCEEDED") {
          this.$message.success("修改成功");
          this.isEdit = false;
          this.loadStandConf(false);
        } else {
          this.$message.error("修改失败," + data.msg);
          this.loading.standard = false;
        }
      });
    },
    // 设置实时数据为标准参数
    setStandByrealData() {
      this.standConf = this.realData;
      this.saveStandConf();
    },
    // 图表数据切换
    changeSelectType() {
      let type = this.option.selectType;
      this.dealChartsData(type);
    },
    //整理echarts数据,获取实时曲线，标准曲线，x轴数据
    dealChartsData(type) {
      let real = this.realData,
        stand = this.standConf;
        let that = this;

        function repeatData(data){
            if(!data.length){
                return data
            }
            let json={},item,jsonItem;
            for(let i =0 ;i<data.length;i++){
                item = data[i];
                jsonItem=json[item.th];
                if(jsonItem){
                    jsonItem.data=Lib.M.getMax(jsonItem.data, item.data);
                    jsonItem.count=1

                }else{
                    jsonItem={};
                    jsonItem.th=item.th;
                    jsonItem.key=item.key;
                    jsonItem.data=item.data;
                    jsonItem.count=1
                }
                json[item.th]=jsonItem
            }
            let arr=[],arrItem;
            for (let x in json){
                arrItem = json[x];
                arrItem.data=Math.floor(arrItem.data/arrItem.count);
                arr.push(arrItem)
            }
            return arr
        }

      /**
       * 对实时数据的处理
       * @argument data
       */
      function dataForEach(data) {
          data=repeatData(data);
        let result = [],
          xData = [],
          DataLength;
        // 将间断数据x轴标记为NONE，然后将间断数据标记为“-”
        DataLength = data[data.length - 1].th * 1 + 2;
        let maxPos = DataLength;
        if (type === "shaojie"){
          maxPos = that.max_pt;
        }else{
          maxPos = that.max_dry;
        }
        if (maxPos > DataLength){
          DataLength = maxPos;
        }
        for (let i = 0; i <= DataLength; i++) {
          if (i === 0) {
            xData[i] = "0";
            result[i] = "30";
          } else if (i === DataLength - 1) {
            xData[i] = i+1;
            result[i] = "30";
          } else {
            xData[i] = "-";
            result[i] = "-";
          }
          data.forEach(function(item, n) {
            if (i == item.th) {
              xData[i] = item.key;
              result[i] = item.data;
            }
          }, this);
        }
        return { xData, result };
      }

      try {
        this.chartsData.xAxisData = dataForEach(real[type]).xData;
        this.chartsData.realData = dataForEach(real[type]).result;
      } catch (error) {
        console.error({
          error,
          data: { real, stand },
          msg: "标准参数echats图表数据解析失败"
        });
      }
      try {
        this.chartsData.standData = dataForEach(stand[type]).result;
      } catch (error) {
        console.error({
          error,
          data: { real, stand },
          msg: "标准参数echats图表数据解析失败"
        });
      }

      // 绘图
      this.$nextTick(() => {
        // if (this.charts) {
        //   this.charts.resize()
        // } else {
        this.initChart(this.chartsData);
        // }
      });
    },

    /**
     * 渲染图表 设置全局charts对象
     */
    initChart(data) {
      let charts;
      if (this.$refs.charts) {
        charts = echarts.init(this.$refs.charts, charts, {
          height: 300
        });
      } else {
        return false;
      }

      let option = {
        baseOption: {
          tooltip: {
            show: true,
            trigger: "axis"
          },
          legend: {
            data: ["标准温度", "实时温度"],
            bottom: 0
          },
          xAxis: {
            show: false,
            data: data.xAxisData,
            axisLabel: {
              show: true,
              interval: function(index, value) {
                if (value == "NONE") {
                  return false;
                } else {
                  return true;
                }
              }
            }
          },
          yAxis: {
            axisLine: { show: false },
            splitLine: {
              show: true
            },
            axisTick: {
              show: false
            }
          },
          series: [
            {
              name: "标准温度",
              type: "line",
              data: data.standData,
              itemStyle: {
                normal: {
                  color: "#76e191",
                  borderWidth: 2
                }
              },
              smooth: "true",
              connectNulls: true,
              lineStyle: {
                normal: {
                  width: "3"
                }
              }
            },
            {
              name: "实时温度",
              type: "line",
              data: data.realData,
              itemStyle: {
                normal: {
                  color: "#eb5650"
                }
              },
              smooth: "true",
              connectNulls: true,
              lineStyle: {
                normal: {
                  width: "3"
                }
              }
            }
          ]
        }
      };
      charts.setOption(option);
      this.charts = charts;
    },
    // 查询设备状态
    // loadDevice() {
    //   let params = {
    //     device_id: this.deviceInfo.device_id,
    //   }
    //   if (this.userInfo.identity === 'USER') {
    //     params.auth_token = this.userInfo.token
    //   }else{
    //     customer_token: this.userInfo.token
    //   }
    //   Lib.api.loadDevice(params, (data) => {
    //     if (data.status_code !== 'SUCCEEDED') {
    //       this.$message.error(data.msg)
    //     } else {
    //       let device = data.payload
    //       device.device_id = device.device_id.$oid
    //       this.$store.dispatch("setDeviceInfo", device)
    //     }
    //   })
    // },
    // 修改砖类型类型
    changeStandType() {
      this.loadStandConf(false);
    },
    openSetStandType() {
      this.dialog.standType = true;
    },
    saveStandType() {
      let payload = {
        brick_list: this.stand.list
      };
      let params = {
        device_id: this.deviceInfo.device_id,
        sys_alias: this.option.aliasNo.toString(),
        conf_type: "brick",
        payload: JSON.stringify(payload)
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      Lib.api.setDeviceConf(params, data => {
        if (data.status_code === "SUCCEEDED") {
          this.$message.success("修改成功");
          this.dialog.standType = false;
          this.loadStandConf(false);
        } else {
          this.$message.error("修改失败");
        }
        console.log(data);
      });
    }
  }
};
</script>

<style scoped>
.card-body {
  margin-top: 20px;
}

.chars-title {
  text-align: center;
}

.chars-header {
  font-size: 0.22rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header-title > span {
  font-size: 0.12rem;
}

.no-padding .el-card__body {
  padding: 0;
}

.table th {
  min-width: 60px;
}

@media screen and (max-width: 900px) {
  .chars-header {
    font-size: 0.23rem;
  }

  .quxian .chars-header {
    display: block;
  }

  .chars-header > .chars-info {
    margin-top: 20px;
    font-size: 0.17rem;
    text-align: center;
  }

  .small-card > div {
    width: 100%;
    margin-right: 0px;
  }

  .mobile-top-bar > div:first-child {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .mobile-top-bar > div:first-child > div {
    width: 30%;
  }

  .mobile-top-bar > div:nth-child(2) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .phone-his-button {
    text-align: center;
    margin: 10px 0;
  }
}
</style>
<style>
.realData .el-table th {
  background: none;
}

.realData .el-table td {
  border: none;
}

.el-table__fixed-header-wrapper thead div,
.realData .el-table__footer-wrapper thead div,
.el-table__header-wrapper thead div {
  background: none;
}

.realData th,
.realData td {
  font-size: 0.18rem;
  text-align: center;
}

.realData .table-time {
  font-size: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// standardSet.vue?3ec5c2e0